import React from 'react';
import MainPage from './MainPage';

const OurDay = () => {
  return <MainPage tag='DAY' title='OUR_DAY' url='/our-day'/>;
}

export default OurDay;